import { postJson, post } from '../../http'
export default {
  getHelpList(params) {
    return postJson('/ConfigureReports/formconfig/getHelpList', params)
  },
}
